"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
/**
 * @author Kadmos.Balkhchyan on 12/16/2019
 */
var SubwayMapComponent = /** @class */ (function () {
    function SubwayMapComponent(currentLanguageProvider) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.translateSize = 284;
        this.moveSize = 0;
        this.initialSpace = 40;
    }
    SubwayMapComponent.prototype.ngOnInit = function () {
        // this.loadCurrentLanguage();
        this.subwayInit();
    };
    // private loadCurrentLanguage() {
    //     this.currentLanguageProvider.getCurrentLanguage()
    //         .subscribe((language: Language) => {
    //             this.isRtl = language.getDirection() === LanguageDirection.RTL;
    //         });
    // }
    // private loadCurrentLanguage() {
    //     this.currentLanguageProvider.getCurrentLanguage()
    //         .subscribe((language: Language) => {
    //             this.isRtl = language.getDirection() === LanguageDirection.RTL;
    //         });
    // }
    SubwayMapComponent.prototype.subwayInit = 
    // private loadCurrentLanguage() {
    //     this.currentLanguageProvider.getCurrentLanguage()
    //         .subscribe((language: Language) => {
    //             this.isRtl = language.getDirection() === LanguageDirection.RTL;
    //         });
    // }
    function () {
        var childReallySize = this.subwayMap.nativeElement.offsetWidth + this.initialSpace;
        if (childReallySize > this.subwayContainer.nativeElement.offsetWidth) {
            this.contFixed = true;
            this.showPrevButton = true;
        }
    };
    SubwayMapComponent.prototype.subwayResize = function () {
        this.noTransition = false;
        var childElement = this.subwayMap.nativeElement.getBoundingClientRect();
        var parentElement = this.subwayContainer.nativeElement.getBoundingClientRect();
        this.leftDiff = childElement.left - this.initialSpace - parentElement.left;
        this.rightDiff = childElement.right + this.initialSpace - parentElement.right;
        var childReallySize = this.subwayMap.nativeElement.offsetWidth + this.initialSpace;
        if (childReallySize > this.subwayContainer.nativeElement.offsetWidth && !this.showNextButton) {
            this.contFixed = true;
            this.showPrevButton = true;
        }
        else if (childReallySize > this.subwayContainer.nativeElement.offsetWidth && this.showNextButton) {
            this.showPrevButton = true;
            if (this.isRtl) {
                if (this.rightDiff <= 0) {
                    this.moveSize -= this.rightDiff;
                    this.showPrevButton = false;
                    this.noTransition = true;
                }
            }
            else {
                if (this.leftDiff >= 0) {
                    this.moveSize -= this.leftDiff;
                    this.showPrevButton = false;
                    this.noTransition = true;
                }
            }
        }
        else {
            this.contFixed = false;
            this.showPrevButton = false;
            this.showNextButton = false;
            this.moveSize = 0;
        }
    };
    SubwayMapComponent.prototype.prevClicked = function () {
        this.showNextButton = true;
        this.noTransition = false;
        if (this.isRtl) {
            this.moveSize += -this.translateSize;
        }
        else {
            this.moveSize += this.translateSize;
        }
        var childElement = this.subwayMap.nativeElement.getBoundingClientRect();
        var parentElement = this.subwayContainer.nativeElement.getBoundingClientRect();
        /**
                 * if subway map moved to the left hiding prev button and moving transition to the end
                 */
        if (this.isRtl) {
            if (childElement.right - this.translateSize <= parentElement.right) {
                this.showPrevButton = false;
                this.moveSize = this.subwayContainer.nativeElement.offsetWidth -
                    this.subwayMap.nativeElement.offsetWidth -
                    this.initialSpace;
            }
        }
        else {
            if (childElement.left + this.translateSize >= parentElement.left) {
                this.showPrevButton = false;
                this.moveSize = this.subwayMap.nativeElement.offsetWidth -
                    this.subwayContainer.nativeElement.offsetWidth +
                    this.initialSpace;
            }
        }
    };
    SubwayMapComponent.prototype.nextClicked = function () {
        this.noTransition = false;
        this.showPrevButton = true;
        if (this.isRtl) {
            this.moveSize += this.translateSize;
            if (this.moveSize >= 0) {
                this.showNextButton = false;
                this.moveSize = 0;
            }
        }
        else {
            this.moveSize -= this.translateSize;
            if (this.moveSize <= 0) {
                this.showNextButton = false;
                this.moveSize = 0;
            }
        }
    };
    SubwayMapComponent.prototype.onResize = function () {
        this.subwayResize();
    };
    SubwayMapComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'sis-subway-map',
                    styles: [require('./sis-subway-map.component.css')],
                    template: require('./sis-subway-map.component.html')
                },] },
    ];
    /** @nocollapse */
    SubwayMapComponent.ctorParameters = function () { return [
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
    ]; };
    SubwayMapComponent.propDecorators = {
        "subwayMap": [{ type: core_1.ViewChild, args: ['subwayMap',] },],
        "subwayContainer": [{ type: core_1.ViewChild, args: ['subwayContainer',] },],
        "onResize": [{ type: core_1.HostListener, args: ['window:resize',] },],
    };
    return SubwayMapComponent;
}());
exports.SubwayMapComponent = SubwayMapComponent;
//# sourceMappingURL=sis-subway-map.component.js.map